
import subNav from '~/components/common/subNav.vue'
import articleTab from '~/components/j/articleTab.vue'
import articleList from '~/components/j/articleList.vue'
import articleTitle from '~/components/j/articleTitle.vue'
import articleHot from '~/components/j/articleHot.vue'
import articlePage from '~/components/j/articlePage.vue'
import articleSearch from '~/components/j/articleSearch.vue'
export default {
  name: 'LearnList',
  components: {
    'sub-nav': subNav,
    'article-tab': articleTab,
    'article-list': articleList,
    'article-title': articleTitle,
    'article-hot': articleHot,
    'article-page': articlePage,
    'article-search': articleSearch
  },
  asyncData({ redirect, $api, app, store, route, $cookies, $serverlog, error, $getBrokerDomain }) {
    try {
      // 202205231934222847
      // 202112084304557323
      const lang = store.state.LanguageCode
      // const articleId = route.params.id && route.params.id.split('.')[0]
      const list = $api.list
        .articlelist({
          code: 'education',
          pageindex: 1,
          pagesize: 20,
          platform: 1,
          isapp: 0,
          version: 124
        })
        .catch(() => {
          console.log('articlelist')
        })
      return Promise.all([list]).then((res) => {
        res[0] &&
          res[0].articlelist &&
          res[0].articlelist.items.forEach((item) => {
            // 格式化列表数据
            item.link = `/${lang}/learn/${item.code}.html`
            item.tags.forEach((itemT) => {
              itemT.tagname = itemT.Tagname
            })
            // item.timer = momentTime(item.wiki_timestamp, lang, 0)
          })

        res[0] &&
          res[0].categories &&
          res[0].categories.forEach((item) => {
            // 格式tab数据
            if (item.Code == 'education') item.link = `/${lang}/learnlist.html`
            else if (item.Code == 'jy_kindergarten') item.link = `/${lang}/learnlist/pre-school.html`
            else if (item.Code == 'jy_primaryschool') item.link = `/${lang}/learnlist/elementary.html`
            else if (item.Code == 'jy_middleschool') item.link = `/${lang}/learnlist/middleschool.html`
            else if (item.Code == 'jy_summercamp') item.link = `/${lang}/learnlist/summer-camp.html`
            else if (item.Code == 'jy_highschool') item.link = `/${lang}/learnlist/highschool.html`
            else if (item.Code == 'jy_university') item.link = `/${lang}/learnlist/undergraduate.html`
            else if (item.Code == 'jy_graduation') item.link = `/${lang}/learnlist/graduation.html`
          })
        return {
          list: res[0] && res[0].articlelist ? res[0].articlelist.items : [],
          listTotal: res[0] && res[0].articlelist ? Math.ceil(res[0].articlelist.total / 20) : 0,
          hotarticle: res[0] ? res[0].hotarticle : [],
          categories: res[0] && res[0].categories ? res[0].categories : []
        }
      })
    } catch (err) {
      $serverlog(error(err).message)
    }
  },
  data() {
    return {
      list: [], // 文章数据
      listTotal: 0, // 文章总数量
      pageIndex: 1, // 分页当前页
      nav_data: [
        {
          link: '/',
          text: '首页',
          type: 'a'
        },
        {
          link: '#',
          text: '教育',
          type: 'span'
        }
      ],
      hotarticle: [], // 热点资讯s
      categories: []
    }
  },
  head() {
    return {
      title: this.$t('20456'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('20521')
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: this.googlenav(this.nav_data)
        }
      ]
    }
  },
  methods: {
    get_search() {
      this.$refs.articleSearch.open()
    }
  }
}
